export const verificarPermiso = (arrayDePermiso, tarea, grupoId) => {
  return !!arrayDePermiso?.find((item) => item === tarea);
};
